module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/heading-mv-f7d7a1c5a45e07e638f08b2eaf548a95.png";